/* ZEPHIR - Resenas: desplegar en la ficha, histograma, y sorteo, flechas y
 * entrada del riel del inicio.
 *
 * REGLA QUE SE RESPETA AQUI: nada de lo visible depende de que este JS corra.
 * El CSS deja el histograma con su ancho final, las resenas extra ocultas con el
 * atributo hidden (que el boton quita) y el riel completo y desplazable con
 * el dedo. Si esto no carga, la ficha y el inicio se ven bien; solo faltan la
 * animacion, el desplegar, las flechas y el sorteo. Se aprendio por las malas en
 * el cajon del carrito: cuando la unica puerta de entrada puede fallar, no puede
 * ser la unica puerta de entrada.
 *
 * TAMPOCO SE USA requestAnimationFrame: en pestanas de fondo no se dispara
 * nunca (comprobado en este proyecto), asi que las animaciones van con
 * transiciones de CSS disparadas por IntersectionObserver, no con un bucle.
 */
(function () {
  'use strict';

  /* ---------- ficha: desplegar resenas ---------- */
  function verMas(bloque) {
    var boton = bloque.querySelector('[data-zres-mas]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      var extras = bloque.querySelectorAll('[data-zres-extra]');
      var abierto = boton.getAttribute('data-abierto') === '1';
      for (var i = 0; i < extras.length; i++) {
        if (abierto) { extras[i].setAttribute('hidden', ''); }
        else { extras[i].removeAttribute('hidden'); }
      }
      boton.setAttribute('data-abierto', abierto ? '0' : '1');
      boton.textContent = abierto
        ? (boton.getAttribute('data-mas') || 'Ver todas las reseñas')
        : (boton.getAttribute('data-menos') || 'Ver menos');
      if (!abierto) return;
      var y = bloque.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* ---------- ficha: histograma al entrar en pantalla ---------- */
  function animarHistograma(bloque) {
    if (!('IntersectionObserver' in window)) return;
    if (!bloque.querySelector('.zres__barra')) return;
    bloque.classList.add('zres--anim');
    var obs = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        if (entradas[i].isIntersecting) {
          bloque.setAttribute('data-zres-visto', '');
          obs.disconnect();
        }
      }
    }, { threshold: 0.25 });
    obs.observe(bloque);
  }

  /* ======================================================================
   * INICIO: SORTEO DE LAS RESENAS
   *
   * El cliente lo pidio: "que de todas las que hay vayan saliendo
   * aleatoriamente no siempre las mismas". Liquid no tiene filtro aleatorio, y
   * aunque lo tuviera Shopify cachea la pagina, asi que el azar del servidor
   * quedaria congelado. El servidor pinta unas cuantas deterministas (visibles
   * sin JS) y aqui se sustituye su contenido por otras del pool de 36.
   *
   * LA SEMILLA SE GUARDA UNA VEZ POR VISITA, en sessionStorage. Con
   * Math.random() suelto, cualquier repintado -- el editor de temas reinyecta
   * secciones, y shopify:section:load vuelve a llamar aqui -- sacaria otras
   * distintas y el riel daria un salto delante del usuario. Con semilla, el
   * mismo sorteo mientras dure la pestana y otro distinto en la siguiente
   * visita.
   *
   * Si sessionStorage falla (modo privado en algunos navegadores, cookies
   * bloqueadas), se cae a un azar sin memoria: peor que con semilla, mucho mejor
   * que romperse. Por eso va en try/catch y no en un `if` de disponibilidad: en
   * algunos navegadores la propiedad EXISTE y lanza al usarla.
   *
   * SI EL POOL NO ES MAS GRANDE QUE LO PINTADO, NO SE SORTEA. Barajar nueve
   * elementos para ensenar nueve solo cambia el orden: da la sensacion de que
   * algo se mueve sin anadir ni una resena nueva.
   * ====================================================================== */
  function semillaVisita() {
    try {
      var s = sessionStorage.getItem('zph-res-semilla');
      if (!s) {
        s = String(1 + Math.floor(Math.random() * 2147483646));
        sessionStorage.setItem('zph-res-semilla', s);
      }
      var n = parseInt(s, 10);
      if (n > 0) return n;
    } catch (e) { /* sin memoria: azar de una sola vez */ }
    return 1 + Math.floor(Math.random() * 2147483646);
  }

  /* Generador con semilla (Lehmer). Hace falta uno propio porque Math.random()
     no acepta semilla y necesitamos repetir el mismo sorteo en un repintado. */
  function generador(semilla) {
    var s = semilla % 2147483647;
    if (s <= 0) s += 2147483646;
    return function () {
      s = (s * 16807) % 2147483647;
      return (s - 1) / 2147483646;
    };
  }

  /* Iniciales del avatar. TIENE QUE ESTAR AQUI ADEMAS DE EN EL LIQUID: el
   * servidor pinta las de la resena que le toco y el sorteo cambia el nombre;
   * sin esto quedaria un avatar "MA" bajo el nombre de otra persona.
   * Sin barras invertidas a proposito: los bloques de texto de la API no
   * procesan los escapes y un `[ ]` literal hace exactamente lo mismo que la
   * clase de espacios (ver el LEEME del borrador). */
  function iniciales(nombre) {
    var n = String(nombre || '').replace(/[ ]+/g, ' ').trim();
    if (!n) return '';
    var p = n.split(' ');
    var a = p[0].charAt(0) || '';
    var b = p.length > 1 ? (p[1].charAt(0) || '') : '';
    return (a + b).toUpperCase();
  }

  /* Pinta una resena del pool sobre una tarjeta ya existente.
   *
   * OJO CON LA FOTO, que es el fallo grave que se evita aqui: si la resena
   * sorteada NO trae foto y la tarjeta ya tenia una, quedaria la FOTO DE UNA
   * RESENA CON EL TEXTO DE OTRA -- una prenda que no es la que se comenta. Asi
   * que cuando no hay foto se RETIRA la imagen y el hueco se queda con el fondo
   * neutro del contenedor. Vale mas un hueco que una foto que miente.
   *
   * Los textos se ponen con textContent y no con innerHTML: son datos que vienen
   * de un metafield y no tienen por que ser marcado. Por eso mismo la cita lleva
   * las comillas tipograficas FUERA del nodo que se sustituye: se escribe
   * `&ldquo;<span data-zres-txt>…</span>&rdquo;` y aqui solo se toca el span,
   * asi que las comillas sobreviven al sorteo. */
  function pintar(tarjeta, it) {
    if (it.handle) tarjeta.setAttribute('href', '/products/' + it.handle);

    var img = tarjeta.querySelector('[data-zres-foto]');
    if (it.foto) {
      if (img) { img.setAttribute('src', it.foto); }
    } else if (img && img.parentNode) {
      img.parentNode.removeChild(img);
    }

    var txt = tarjeta.querySelector('[data-zres-txt]');
    if (txt) txt.textContent = it.txt || '';
    var nom = tarjeta.querySelector('[data-zres-nombre]');
    if (nom) nom.textContent = it.nombre || '';
    var prod = tarjeta.querySelector('[data-zres-prod]');
    if (prod) prod.textContent = it.producto || '';
    var ini = tarjeta.querySelector('[data-zres-ini]');
    if (ini) ini.textContent = iniciales(it.nombre);

    var est = tarjeta.querySelector('[data-zres-est]');
    if (est) {
      var n = parseInt(it.est, 10);
      if (!(n > 0)) n = 5;
      est.setAttribute('aria-label', n + ' de 5');
      var on = est.querySelector('.zres-est__on');
      if (on) on.style.width = (n * 20) + '%';
    }
  }

  function sortear(nodo) {
    var caja = nodo.querySelector('[data-zres-pool]');
    var tarjetas = nodo.querySelectorAll('[data-zres-tesela]');
    if (!caja || !tarjetas.length) return;

    var pool;
    try { pool = JSON.parse(caja.textContent); } catch (e) { return; }
    if (!pool || !pool.length) return;
    if (pool.length <= tarjetas.length) return;   // sin margen, no hay sorteo

    var rnd = generador(semillaVisita());
    var idx = [];
    for (var i = 0; i < pool.length; i++) idx.push(i);
    for (var j = idx.length - 1; j > 0; j--) {          // Fisher-Yates
      var k = Math.floor(rnd() * (j + 1));
      var tmp = idx[j]; idx[j] = idx[k]; idx[k] = tmp;
    }
    for (var n = 0; n < tarjetas.length; n++) {
      var it = pool[idx[n]];
      if (it) pintar(tarjetas[n], it);
    }
  }

  /* ---------- inicio: flechas del riel ----------
   * El riel se recorre EN HORIZONTAL porque la seccion tiene que caber en una
   * pantalla. En movil se arrastra con el dedo y el CSS esconde las flechas; en
   * escritorio, con raton, un desplazamiento horizontal sin pista no se
   * descubre. Cada pulsacion avanza DOS piezas: con columnas de ~300 px, de una
   * en una parece que no pasa nada. Si todo cabe, las dos salen desactivadas, y
   * esa es la senal correcta. */
  function flechas(nodo) {
    var pista = nodo.querySelector('.zrie__mosaico');
    if (!pista) return;
    var atras = nodo.querySelector('[data-zrie-atras]');
    var adelante = nodo.querySelector('[data-zrie-adelante]');
    if (!atras && !adelante) return;

    function paso() {
      var t = pista.querySelector('.zrie__c');
      if (!t) return pista.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 16;
      return (t.getBoundingClientRect().width + gap) * 2;
    }
    function estado() {
      var max = pista.scrollWidth - pista.clientWidth - 2;
      if (atras) atras.disabled = pista.scrollLeft <= 2;
      if (adelante) adelante.disabled = pista.scrollLeft >= max;
    }
    if (atras) atras.addEventListener('click', function () {
      pista.scrollBy({ left: -paso(), behavior: 'smooth' });
    });
    if (adelante) adelante.addEventListener('click', function () {
      pista.scrollBy({ left: paso(), behavior: 'smooth' });
    });
    pista.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  }

  /* ---------- inicio: entrada del riel ----------
   * Cada resena entra por su cuenta, no la seccion de golpe: animarlas todas a
   * la vez se ve como un parpadeo. El desfase lo pone el CSS con
   * transition-delay por :nth-child, no un setTimeout por tarjeta. */
  function mosaico(nodo) {
    var piezas = nodo.querySelectorAll('.zrie__c');
    if (!piezas.length) return;
    if (!('IntersectionObserver' in window)) return;

    nodo.classList.add('zrie--anim');

    var entregado = false;
    var obs = new IntersectionObserver(function (entradas) {
      entregado = true;
      for (var i = 0; i < entradas.length; i++) {
        if (!entradas[i].isIntersecting) continue;
        entradas[i].target.setAttribute('data-visto', '');
        obs.unobserve(entradas[i].target);
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    for (var j = 0; j < piezas.length; j++) obs.observe(piezas[j]);

    /* RED DE SEGURIDAD, y no es teorica. Con .zrie--anim puesta, las resenas
     * nacen invisibles y solo aparecen cuando el observador avisa. Si no avisa
     * nunca, la seccion se queda en blanco. Y puede no avisar: comprobado el
     * 2026-08-31, Chrome SUSPENDE la entrega de callbacks de
     * IntersectionObserver en pestanas de segundo plano -- un observador recien
     * creado no recibio ni una entrega en 2,5 segundos con document.hidden.
     * Por especificacion, observe() dispara una primera entrega enseguida
     * incluso si el elemento no esta visible; si al segundo largo no ha llegado
     * ninguna, se retira la clase y se ven todas, sin animacion. */
    setTimeout(function () {
      if (!entregado) nodo.classList.remove('zrie--anim');
    }, 1200);
  }

  function arrancar() {
    var bloques = document.querySelectorAll('[data-zres]');
    for (var i = 0; i < bloques.length; i++) {
      verMas(bloques[i]);
      animarHistograma(bloques[i]);
    }
    var mosaicos = document.querySelectorAll('[data-zrie-mosaico]');
    for (var j = 0; j < mosaicos.length; j++) {
      sortear(mosaicos[j]);     // primero el contenido...
      flechas(mosaicos[j]);     // ...y luego lo que mide y observa
      mosaico(mosaicos[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();